import { render, staticRenderFns } from "./optionSet.vue?vue&type=template&id=23458d9b&scoped=true"
import script from "./optionSet.vue?vue&type=script&lang=js"
export * from "./optionSet.vue?vue&type=script&lang=js"
import style0 from "./optionSet.vue?vue&type=style&index=0&id=23458d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23458d9b",
  null
  
)

export default component.exports